import { Helmet } from "react-helmet-async";

const SITE = "https://cologne-card-con.de";

/**
 * Per-page SEO tags for the SPA. Manages title, description and canonical per
 * route (Googlebot executes JS and picks these up). Open Graph / Twitter cards
 * stay static in index.html so non-JS social scrapers still get a valid preview.
 */
export const Seo = ({ title, description, path = "", jsonLd, noindex = false }) => {
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        />
      )}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};
